import {
  GET_EVENT_ATTRIBUTES_REQUEST,
  GET_EVENT_ATTRIBUTES_SUCCESS,
  GET_EVENT_ATTRIBUTES_FAILURE,
  EventAttributesActionTypes,
  EventAttributesState,
} from './eventAttributes.types';

const initialState: EventAttributesState = {
  eventAttribute: null,
  loading: false,
  error: null,
};

const eventAttributesReducer = (
  state: EventAttributesState = initialState,
  action: EventAttributesActionTypes
): EventAttributesState => {
  switch (action.type) {
    case GET_EVENT_ATTRIBUTES_REQUEST:
      return {
        ...state,
        eventAttribute: null,
        loading: true,
        error: null,
      };
    case GET_EVENT_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        eventAttribute: action.payload,
        error: null,
      };
    case GET_EVENT_ATTRIBUTES_FAILURE:
      return {
        ...state,
        eventAttribute: null,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default eventAttributesReducer;
